import { Component, OnInit, inject } from "@angular/core";
import { VisitTypeStore } from "@app/services/store/visit-type-store";

import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { BaseSingleEntityPageComponent } from "@app/view/shared/base-pages/base-single-entity-page/base-single-entity-page.component";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { VisitType } from "@app/models/rest/visit-type";

import { SorCode } from "@app/models/rest/sor-code";
import { SorCodeStore } from "@app/services/store/sor-code-store";
import {
  ChildEntityDeletionBehaviour,
  ChildEntityModel
} from "@app/view/shared/child-entity-manager/child-entity-model";
import { ChildEntityDisplayComponent } from "@app/view/shared/child-entity-display/child-entity-display.component";
import { SkillProfile } from "@app/models/rest/skill-profile";
import { SkillProfileStore } from "@app/services/store/skill-profile-store";
import { VisitTypeResource } from "@app/models/rest/visit-type-resource";
import { VisitTypeResourceStore } from "@app/services/store/visit-type-resource-store";
import { VisitTypeSorCodeAddComponent } from "@app/view/setup/assignment/visit-type-sor-code-add/visit-type-sor-code-add.component";
import { VisitTypeSkillProfileAddComponent } from "@app/view/setup/assignment/visit-type-skill-profile-add/visit-type-skill-profile-add.component";
import { MatAnchor, MatButton } from "@angular/material/button";
import { MatProgressBar } from "@angular/material/progress-bar";
import {
  MatCard,
  MatCardHeader,
  MatCardActions,
  MatCardAvatar,
  MatCardTitle,
  MatCardSubtitle,
  MatCardContent
} from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { MatAccordion } from "@angular/material/expansion";
import { ChildEntityManagerComponent } from "../../../shared/child-entity-manager/child-entity-manager.component";
import { TranslatePipe } from "@ngx-translate/core";
import { VisitTypeResourceGridComponent } from "@app/view/setup/assignment/visit-type-resource-grid/visit-type-resource-grid.component";

@Component({
  selector: "app-visit-type-detail",
  templateUrl: "./visit-type-detail.component.html",
  styleUrls: ["./visit-type-detail.component.scss"],
  imports: [
    MatAnchor,
    RouterLink,
    MatProgressBar,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardSubtitle,
    MatCardActions,
    MatCardContent,
    MatButton,
    MatCardAvatar,
    MatIcon,
    MatAccordion,
    ChildEntityManagerComponent,
    TranslatePipe,
    VisitTypeResourceGridComponent
  ]
})
export class VisitTypeDetailComponent
  extends BaseSingleEntityPageComponent<VisitType>
  implements OnInit
{
  protected visitTypeService = inject(VisitTypeStore);
  sorCodeService = inject(SorCodeStore);
  skillProfileStore = inject(SkillProfileStore);
  protected visitTypeResourceStore = inject(VisitTypeResourceStore);
  visitTypeStore = inject(VisitTypeStore);

  public childEntities: {
    sorCode: ChildEntityModel<SorCode, VisitType>;
    visitTypeResourceList: ChildEntityModel<VisitTypeResource, VisitType>;
  } = { sorCode: null, visitTypeResourceList: null };

  // @Input()
  visitType: VisitType = null;

  // sorCodes: SorCode[] = [];

  constructor() {
    super();

    this.childEntities.sorCode = {
      type: SorCode,
      relation: "sorCode",
      display: "code",
      title: "scheduler.visitType-detail.sorCodes.title",
      addComponent: VisitTypeSorCodeAddComponent,
      displayComponent: ChildEntityDisplayComponent,
      searchKey: "visitType",
      readonly: true,
      store: this.sorCodeService,
      searchQuery: "findByVisitType",
      deletionBehaviour: ChildEntityDeletionBehaviour.RELATIONSHIP,
      parentStore: null,
      parentType: null,
      parentRelation: null
    };

    this.childEntities.visitTypeResourceList = {
      type: SkillProfile,
      relation: "skillProfile",
      display: "description",
      title: "scheduler.visitType-detail.skillProfile.title",
      addComponent: VisitTypeSkillProfileAddComponent,
      displayComponent: ChildEntityDisplayComponent,
      searchKey: "visitType",
      readonly: false,
      store: this.visitTypeResourceStore,
      searchQuery: "findByVisitType",
      deletionBehaviour: ChildEntityDeletionBehaviour.LINK_TABLE,
      parentStore: null,
      parentType: SkillProfile,
      parentRelation: "skillProfiles"
    };
  }

  ngOnInit() {
    this.visitTypeStore.entity.subscribe((visitTypeR) => {
      this.visitType = visitTypeR;
    });
    super.loadDataSource(this.visitTypeService);
  }

  retryLoad() {
    super.retry(this.visitTypeService);
  }

  // updateVisitType() {
  //   this.visitTypeStore
  //     .update(this.visitType)
  //     .subscribe((saved: VisitType) => {
  //       saved.addRelation('sorcode', this.VisitTypeSorCode.value).subscribe(value => {
  //         console.log('visittype updated');
  //       });
  //     });
  // }

  // compareObjects(objA: SorCode, objB: SorCode) {
  //   if (objA.code === objB.code) {
  //     return true;
  //   }
  //   return false;
  // }
}
